'use client'

import { Builder } from '@builder.io/react'

import { FeaturedChartDefaults } from '@src/components/FeaturedChart/FeaturedChart.defaults'

import { FeaturedChart } from './FeaturedChart'

Builder.registerComponent(FeaturedChart, {
  name: 'FeaturedChart',
  inputs: [
    {
      name: 'blocksBottom',
      hideFromUI: true,
      type: 'uiBlocks',
      defaultValue: FeaturedChartDefaults.blocksBottom,
    },
    {
      name: 'featuredColumnHeader',
      type: 'text',
      defaultValue: FeaturedChartDefaults.featuredColumnHeader,
    },
    {
      name: 'heading',
      type: 'text',
      defaultValue: FeaturedChartDefaults.heading,
    },
    {
      name: 'rowHeadings',
      type: 'list',
      defaultValue: FeaturedChartDefaults.rowHeadings,
      subFields: [
        {
          name: 'text',
          type: 'html',
        },
      ],
    },
    {
      name: 'rows',
      type: 'list',
      defaultValue: FeaturedChartDefaults.rows,
      subFields: [
        {
          name: 'blocks',
          type: 'uiBlocks',
          hideFromUI: true,
        },
        {
          name: 'content',
          type: 'list',
          defaultValue: '',
          subFields: [
            {
              name: 'icon',
              type: 'string',
              defaultValue: 'checkmark',
              enum: ['checkmark', 'x', 'dash'],
            },
          ],
        },
      ],
    },
  ],
})
